import React, { Component } from "react";

import { PropertyPanelContainer, PropertySection } from "../../../EditorComponents/PropertyPanel";
import { ShowDialog, ShowDialogAsync } from "../../../react/components/Dialogs/BaseDialog";
import { _ } from "../../../vendor";
import styled from "styled-components";
import { CanvasEventType } from "../../../../common/constants";
import { PropertyPanelButton } from "../../../EditorComponents/PropertyPanelButton";
import { themeColors } from "../../../react/sharedStyles";
import { PropertyPanelHeader } from "../../ElementEditor/PropertyPanelHeader";
import PresentationEditorController from "../../PresentationEditor/PresentationEditorController";
import SlideAiController from "./SlideAiController";
import SlideAiDialog from "./SlideAiDialog";
import SlideAiIdeasList from "./SlideAiIdeasList";
import { RegenerateImageDialog } from "../GenerateImage/RegenerateImageDialog";
import { FlexSpacer } from "../../../react/components/Gap";
import { Button } from "../../../Components/Button";
import { Icon } from "../../../Components/Icon";
import { AiIcon } from "../AiIcon";

const SlidePreviews = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
    padding: 10px 15px;
`;

const SlideCategory = styled.div`
    display: flex;
    gap: 10px;
    flex-direction: column;
`;

const CategoryLabel = styled.div`
    display: flex;
    font-weight: bold;
    padding: 10px 0px 0px;
    align-items: center;
    justify-content: center;
`;

const CanvasPreviewWrapper = styled.div`
    position: relative;
    width: 250px;
    height: 140px;
    cursor: pointer;
    border: solid 1px #ccc;
    overflow: hidden;
    outline: ${props => props.selected ? `3px solid ${themeColors.ui_blue}` : "none"};
`;

class SlideAiIdeasPanel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentModel: _.cloneDeep(props.currentSlide.attributes),
            isGenerating: false,
            selectedModel: null,
            slideCategory: null,
            slideCategories: [],
            // generatedSlides: props.currentSlide.getMetadata()?.generatedSlides ?? []
        };

        this.hasBeenUnmounted = false;

        this.slideAiIdeasListRef = React.createRef();
    }

    componentDidMount() {
        const { currentSlide, canvasController } = this.props;
        // if (currentSlide.getMetadata()?.hasBeenViewed === false) {
        currentSlide.updateMetadata({ hasBeenViewed: true });

        // if (SlideAiController.currentSlide !== currentSlide) {
        //     SlideAiController.setCurrentSlide(currentSlide, canvasController);
        // }
    }

    componentDidUpdate(prevProps, prevState) {
        const { canvasController, currentSlide } = this.props;

        if (prevProps.currentSlide !== currentSlide) {
            this.setState({
                currentModel: _.cloneDeep(currentSlide.attributes),
                isGenerating: false,
                selectedModelIndex: null,
                slideCategory: null
            });
        }
    }

    componentWillUnmount() {
        this.hasBeenUnmounted = true;
    }

    shouldComponentUpdate(nextProps) {
        return !nextProps.canvasController?.canvas?.isAnimating;
    }

    setStateAsync = async stateUpdate => {
        await new Promise(resolve => this.setState(stateUpdate, resolve));
    }

    handleRegenerateSlide = () => {
        const { currentSlide, currentCanvasController } = this.props;
        let { ideas } = ShowDialog(SlideAiDialog, { currentSlide, currentCanvasController });
        this.setState({ generatedSlides: ideas });
    }

    handleRegenerateImage = async () => {
        const { currentSlide, currentTheme } = this.props;

        const metadata = currentSlide.getMetadata();
        const slideImage = metadata.generatedModel?.slideImage;
        const imageSource = metadata.imageSource ?? "ai";

        let { imagePrompt, imageStyle } = await ShowDialogAsync(RegenerateImageDialog, {
            currentSlide,
            theme: currentTheme,
            prompt: slideImage?.prompt || "",
            imageSource: imageSource,
            imageStyle: slideImage?.imageStyle || "minimalist",
        });

        SlideAiController.regenerateSlideImage(imagePrompt, imageStyle);
    }

    handleApplySlide = model => {
        const { currentSlide, currentCanvasController, closePopup } = this.props;

        currentCanvasController.canvas.once(CanvasEventType.REFRESH, () => {
            // this.props.closeDialog();
            window.requestAnimationFrame(() => {
                PresentationEditorController.playAnimation();
            });
        });

        currentSlide.update({
            ...currentSlide.attributes,
            animations: {},
            states: model.states,
            layout: model.layout,
            template_id: model.template_id,
            version: 10,
            migrationVersion: 10.03,
            metadata: {
                ...model.metadata,
                needsLayoutProcessing: true
            }
        }, { removeMissingKeys: true });
    }

    render() {
        let { currentSlide, generatedIdeas } = this.props;
        let { isGenerating } = this.state;

        if (currentSlide !== SlideAiController.currentSlide) {
            return null;
        }

        if (generatedIdeas?.length > 0 || isGenerating) {
            return (
                <PropertyPanelContainer fullHeight style={{ background: "#444" }}>
                    {/*<PropertyPanelHeader showCloseButton>Slide AI</PropertyPanelHeader>*/}
                    <PropertyPanelHeader>
                        Slide AI
                    </PropertyPanelHeader>
                    {/*<PropertySection>*/}
                    {/*    <Button unframed textColor={themeColors.aiColor}><AiIcon iconColor={themeColors.aiColor} />Generate Ideas...</Button>*/}
                    {/*</PropertySection>*/}
                    <PropertyPanelButton icon="change_circle"
                        title="Generate Ideas..."
                        description="Switch any other smart slide and we'll try to preserve your existing content as best we can."
                        onClick={this.handleRegenerateSlide}
                    />
                    {/*<PropertyPanelButton icon="photo"*/}
                    {/*    title="Regenerate image..."*/}
                    {/*    onClick={this.handleRegenerateImage}*/}
                    {/*    disabled={currentSlide.getMetadata().imageSource === "none"}*/}
                    {/*/>*/}

                    <SlideAiIdeasList currentSlide={currentSlide}
                        generatedSlides={generatedIdeas}
                        slideWidth={290}
                        onSelect={this.handleApplySlide}
                    />

                </PropertyPanelContainer>
            );
        }

        let metadata = currentSlide.getMetadata();

        return (
            <PropertyPanelContainer>
                <PropertyPanelHeader>Slide AI<FlexSpacer /><Button>Generate Ideas...</Button></PropertyPanelHeader>
                {/*<label>Slide Type:{currentSlide.getMetadata().slideType}</label>*/}
                {/*{metadata.slideContent &&*/}
                {/*    <div style={{ padding: 10, fontSize: 14, maxHeight: 300, overflowY: "scroll" }} dangerouslySetInnerHTML={{ __html: metadata?.slideContent }} />*/}
                {/*}*/}
                <PropertyPanelButton icon="change_circle"
                    title="Regenerate Slide..."
                    onClick={this.handleRegenerateSlide}
                />
                <PropertyPanelButton icon="photo"
                    title="Regenerate image..."
                    onClick={this.handleRegenerateImage}
                />
                <PropertyPanelButton icon="add"
                    title="Add slides with AI..."
                />
                {/*<PropertyPanelButton icon="summarize"*/}
                {/*    title="Add conclusion/takeaway..."*/}
                {/*    onClick={() => {*/}
                {/*    }}*/}
                {/*/>*/}
                {/*<PropertyPanelButton icon="photo"*/}
                {/*    title="Add an image..."*/}
                {/*    onClick={() => {*/}
                {/*    }}*/}
                {/*/>*/}
                {/*<PropertyPanelButton icon="spellcheck"*/}
                {/*    title="Rewrite content..."*/}
                {/*    onClick={() => {*/}
                {/*    }}*/}
                {/*/>*/}

            </PropertyPanelContainer>
        );
    }
}

export default SlideAiController.withState(SlideAiIdeasPanel);
